import 'Vendor/owlcarousel/owl.carousel.min';
import { speed } from 'Lib/speed/speed';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { whiteLabel } from 'Lib/white-label/white-label';
import { copytext } from 'Lib/copy-text/copy-text';

const $slider = $('.together-cheaper');
const cOwl = 'owl-carousel';
const sPic = '.together-cheaper__item-img';

function setSlider() {
    if (getW() > eksmoBP.smMax) {
        $slider.trigger('destroy.owl.carousel')
            .removeClass(cOwl)
            .addClass(cOwl)
            .owlCarousel({
                smartSpeed: speed / 2,
                nav: true,
                dots: false,
                navClass: ['together-cheaper__slider-arrow-prev arrow arrow_prev', 'together-cheaper__slider-arrow-next arrow arrow_next'],
                navText: ['', ''],
                onInitialized(e) {
                    onScreen($(e.target).find(sPic), loadSrcOrBg);
                },
            });
    }
}

document.querySelectorAll('.together-cheaper__btn')?.forEach((item) => {
    item.addEventListener('click', (e) => {
        const elParent = item.closest('.together-cheaper__item');
        const basketId = elParent?.getAttribute('data-book24').split(', ');
        const elBtn = elParent?.querySelector('.together-cheaper__btn');
        const sBtnActive = 'together-cheaper__btn_active';
        const sBtnOrder = 'together-cheaper__btn_order';
        const arrBook24Id = [];

        if (!elBtn?.classList.contains(sBtnOrder)) {
            e.preventDefault();
            elBtn.classList.add(sBtnActive);

            basketId.forEach((itemInner) => {
                arrBook24Id.push({
                    productId: itemInner,
                    quantity: 1,
                });
            });

            if (arrBook24Id.length > 0) {
                whiteLabel.applyPromocode(elParent.querySelector('.together-cheaper__promocode-promocode').textContent)
                    .then(() => {
                        whiteLabel.addBookBasketTogether(arrBook24Id)
                            .then(() => {
                                elBtn.classList.remove(sBtnActive);
                                elBtn.textContent = 'Оформить';
                                elBtn.classList.add(sBtnOrder);
                                elBtn.setAttribute('href', 'https://eksmo.ru/cart/#/personal/cart');
                            })
                            .catch(() => console.error('Ошибка в добавлении книг комплектом'));
                    });
            }
        }
    });
});

$('.together-cheaper__promocode-box').on('click', function () {
    copytext($(this).find('.together-cheaper__promocode-promocode'));
});

setSlider();